/* LensDepom theme.js (v4) */
(function () {
  'use strict';

  /* ---------- Yardımcılar ---------- */
  function toast(msg, type) {
    var el = document.getElementById('toast');
    if (!el) return;
    el.textContent = msg;
    el.className = 'toast show ' + (type || '');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.className = 'toast'; }, 3200);
  }

  function money(cents) {
    return (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
      });
  }

  function setTotals(cents) {
    document.querySelectorAll('[data-total]').forEach(function (el) { el.textContent = money(cents); });
  }

  function showError(msg) {
    document.querySelectorAll('[data-error]').forEach(function (el) {
      el.textContent = msg || '';
      el.classList.toggle('show', !!msg);
    });
  }

  function allCtas() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-add-to-cart]'));
  }

  function setCtasBusy(busy) {
    allCtas().forEach(function (b) {
      b.disabled = busy;
      if (busy) { b.dataset.prevText = b.textContent; b.textContent = 'Ekleniyor...'; }
      else if (b.dataset.prevText) { b.textContent = b.dataset.prevText; }
    });
  }

  function addItems(items) {
    setCtasBusy(true);
    return fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Sepete eklenemedi'); });
        return r.json();
      })
      .then(function () {
        toast('Ürün sepete eklendi ✓', 'success');
        updateCartCount();
      })
      .catch(function (err) { toast(err.message, 'error'); })
      .finally(function () { setCtasBusy(false); });
  }

  /* ---------- Mobil menü ---------- */
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-menu-open]');
    var closeBtn = e.target.closest('[data-menu-close], .mobile-drawer__overlay');
    var drawer = document.getElementById('mobileDrawer');
    if (!drawer) return;
    if (openBtn) { drawer.classList.add('open'); document.body.style.overflow = 'hidden'; }
    if (closeBtn) { drawer.classList.remove('open'); document.body.style.overflow = ''; }
  });

  /* ---------- Ürün galerisi ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    var main = document.querySelector('[data-main-image]');
    if (!main) return;
    main.src = thumb.getAttribute('data-thumb');
    document.querySelectorAll('[data-thumb]').forEach(function (b) { b.classList.remove('active'); });
    thumb.classList.add('active');
  });

  /* ---------- Sekmeler ---------- */
  document.addEventListener('click', function (e) {
    var tabBtn = e.target.closest('[data-tab]');
    if (!tabBtn) return;
    var wrap = tabBtn.closest('.pdp-tabs');
    if (!wrap) return;
    wrap.querySelectorAll('[data-tab]').forEach(function (b) { b.classList.remove('active'); });
    wrap.querySelectorAll('.pdp-tabs__panel').forEach(function (p) { p.classList.remove('active'); });
    tabBtn.classList.add('active');
    var panel = document.getElementById(tabBtn.getAttribute('data-tab'));
    if (panel) panel.classList.add('active');
  });

  /* ---------- Lens sipariş formu ---------- */
  function initLensForm(form) {
    var variantId = parseInt(form.getAttribute('data-variant-id'), 10);
    var unitPrice = parseInt(form.getAttribute('data-price'), 10); // kuruş
    var summaryEl = document.querySelector('[data-selection-summary]');

    function eyePanels() {
      return Array.prototype.slice.call(form.querySelectorAll('[data-eye]'));
    }

    function refresh() {
      var total = 0;
      var lines = [];
      eyePanels().forEach(function (panel) {
        var on = panel.querySelector('[data-eye-toggle]').checked;
        panel.classList.toggle('enabled', on);
        if (!on) return;
        var boxesSel = panel.querySelector('[data-field="boxes"]');
        var boxes = boxesSel ? (parseInt(boxesSel.value, 10) || 0) : 0;
        total += boxes * unitPrice;

        var parts = [];
        panel.querySelectorAll('select[data-field]').forEach(function (sel) {
          var f = sel.getAttribute('data-field');
          if (f === 'boxes' || f === 'dia' || f === 'bc') return;
          if (sel.value) parts.push(sel.getAttribute('data-label').split(' ')[0] + ' ' + sel.value);
        });
        lines.push({
          eye: panel.getAttribute('data-eye'),
          detail: parts.join(' · ') || 'numara seçilmedi',
          boxes: boxes
        });
      });

      setTotals(total);
      showError('');

      if (summaryEl) {
        if (!lines.length) {
          summaryEl.innerHTML = '<span class="buybox__summary-empty">Lütfen en az bir göz seçin.</span>';
        } else {
          summaryEl.innerHTML = lines.map(function (l) {
            return '<div class="buybox__line"><b>' + l.eye + '</b><span>' + l.detail + '</span><em>' + l.boxes + ' kutu</em></div>';
          }).join('');
        }
      }
    }

    form.addEventListener('change', refresh);
    refresh();

    function submit() {
      var items = [];
      var valid = true;
      var anyEye = false;

      eyePanels().forEach(function (panel) {
        var on = panel.querySelector('[data-eye-toggle]').checked;
        if (!on) return;
        anyEye = true;
        var props = { 'Göz': panel.getAttribute('data-eye') };
        var boxes = 1;
        panel.querySelectorAll('select[data-field]').forEach(function (sel) {
          sel.classList.remove('is-invalid');
          if (sel.hasAttribute('required') && !sel.value) {
            sel.classList.add('is-invalid');
            valid = false;
            return;
          }
          if (sel.getAttribute('data-field') === 'boxes') {
            boxes = parseInt(sel.value, 10) || 1;
          } else if (sel.value) {
            props[sel.getAttribute('data-label')] = sel.value;
          }
        });
        items.push({ id: variantId, quantity: boxes, properties: props });
      });

      if (!anyEye) { showError('Lütfen en az bir göz seçin (Sol / Sağ).'); return; }
      if (!valid) {
        showError('Lütfen işaretli alanları doldurun.');
        var firstInvalid = form.querySelector('select.is-invalid');
        if (firstInvalid) firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      addItems(items);
    }

    allCtas().forEach(function (btn) { btn.addEventListener('click', submit); });
  }

  /* ---------- Basit ürün formu ---------- */
  function initSimpleForm(form) {
    var variantId = parseInt(form.getAttribute('data-variant-id'), 10);
    var unitPrice = parseInt(form.getAttribute('data-price'), 10) || 0;
    var qtyInput = form.querySelector('[data-qty]');

    function refresh() {
      if (unitPrice) setTotals((parseInt(qtyInput.value, 10) || 1) * unitPrice);
    }

    form.addEventListener('click', function (e) {
      if (e.target.closest('[data-qty-plus]')) { qtyInput.value = parseInt(qtyInput.value, 10) + 1; refresh(); }
      if (e.target.closest('[data-qty-minus]')) { qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1); refresh(); }
    });
    form.addEventListener('change', refresh);
    refresh();

    allCtas().forEach(function (btn) {
      btn.addEventListener('click', function () {
        addItems([{ id: variantId, quantity: parseInt(qtyInput.value, 10) || 1 }]);
      });
    });
  }

  /* ---------- Sepet: adet değiştir / sil ---------- */
  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-line-remove]');
    var plus = e.target.closest('[data-line-plus]');
    var minus = e.target.closest('[data-line-minus]');
    var target = removeBtn || plus || minus;
    if (!target) return;
    var line = parseInt(target.getAttribute('data-line') || (target.closest('[data-line-item]') || {}).getAttribute('data-line'), 10);
    var qtyEl = document.querySelector('[data-line-qty="' + line + '"]');
    var current = qtyEl ? parseInt(qtyEl.value, 10) : 1;
    var quantity = removeBtn ? 0 : (plus ? current + 1 : Math.max(0, current - 1));

    fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () { window.location.reload(); });
  });

  /* ---------- Koleksiyon sıralama ---------- */
  document.addEventListener('change', function (e) {
    var sortSel = e.target.closest('[data-sort]');
    if (!sortSel) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortSel.value);
    window.location.href = url.toString();
  });

  document.addEventListener('DOMContentLoaded', function () {
    var lensForm = document.querySelector('[data-lens-form]');
    var simpleForm = document.querySelector('[data-simple-form]');
    if (lensForm) initLensForm(lensForm);
    else if (simpleForm) initSimpleForm(simpleForm);
    updateCartCount();
  });
})();
